import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { triggerAlert, set_user_permission } from '../utils';
import axios from 'axios';
import Cookies from 'js-cookie';

function Sidebar() {
    const location = useLocation();
    const api_url = process.env.REACT_APP_API_BASE_URL;

    const mainModule = location.pathname.split('/')[1];
    const subModule  = location.pathname.split('/')[2];

    const isMain = (key) => mainModule === key;
    const isSub  = (key) => subModule  === key;

    const [openMenu, setOpenMenu] = useState(mainModule);

    useEffect(() => {
        setOpenMenu(mainModule);
    }, [location.pathname]);

    const toggleMenu = (key) => {
        setOpenMenu((prev) => (prev === key ? '' : key));
    };

    const isOpen = (key) => openMenu === key || isMain(key);

    // Parent <a>: no active class, only parent-active for icon highlight
    const parentCls = (key) => `has-arrow waves-effect${isMain(key) ? ' parent-active' : ''}`;
    // Parent <li>
    const liCls     = (key) => isMain(key) ? 'mm-active' : '';
    // Sub <li> and <a>
    const subLi     = (key) => isSub(key) ? 'mm-active' : '';
    const subA      = (key) => isSub(key) ? 'active' : '';

    const [customers,          setcustomers]          = useState(false);
    const [Billing,            setBilling]            = useState(false);
    const [Reports,            setReports]            = useState(false);
    const [Supports,           setSupports]           = useState(false);
    const [ManageAdmin,        setManageAdmin]        = useState(false);
    const [settings,           setsettings]           = useState(false);
    const [customerslist,      setcustomerslist]      = useState(false);
    const [BillingInformation, setBillingInformation] = useState(false);
    const [PaymentDetails,     setPaymentDetails]     = useState(false);
    const [Invoice,            setInvoice]            = useState(false);
    const [CreateInvoice,      setCreateInvoice]      = useState(false);
    const [Revenue,            setRevenue]            = useState(false);
    const [Userlogs,           setUserlogs]           = useState(false);
    const [ManageTickets,      setManageTickets]      = useState(false);
    const [CreateTickets,      setCreateTickets]      = useState(false);
    const [TicketsCategories,  setTicketsCategories]  = useState(false);
    const [PredefinedReplies,  setPredefinedReplies]  = useState(false);
    const [UserLevel,          setUserLevel]          = useState(false);
    const [UserList,           setUserList]           = useState(false);
    const [Plans,              setPlans]              = useState(false);
    const [Products,           setProducts]           = useState(false);
    const [Buycredit,          setBuyCredit]          = useState(false);
    const [Creditconfig,       setCreditConfig]       = useState(false);
    const [MenuPermissions,    setMenuPermissions]    = useState(false);

    const showpageswith = (arr) => {
        arr.forEach((item) => {
            item.sub_module_info.forEach((sub) => {
                const has = sub.permissions.indexOf(1) !== -1;
                if (sub.name === 'Customer List'          && has) setcustomerslist(true);
                if (sub.name === 'Billing Information'    && has) setBillingInformation(true);
                if (sub.name === 'Payment Details'        && has) setPaymentDetails(true);
                if (sub.name === 'Invoice'                && has) setInvoice(true);
                if (sub.name === 'Create Invoice'         && has) setCreateInvoice(true);
                if (sub.name === 'Revenue'                && has) setRevenue(true);
                if (sub.name === 'User logs'              && has) setUserlogs(true);
                if (sub.name === 'Manage Tickets'         && has) setManageTickets(true);
                if (sub.name === 'Create Tickets'         && has) setCreateTickets(true);
                if (sub.name === 'Tickets Categories'     && has) setTicketsCategories(true);
                if (sub.name === 'Predefined Replies'     && has) setPredefinedReplies(true);
                if (sub.name === 'User Role'              && has) setUserLevel(true);
                if (sub.name === 'User List'              && has) setUserList(true);
                if (sub.name === 'Access Privileges'      && has) setMenuPermissions(true);
                if (sub.name === 'Products'               && has) setProducts(true);
                if (sub.name === 'Plans'                  && has) setPlans(true);
                if (sub.name === 'Buy Additional Credits' && has) setBuyCredit(true);
                if (sub.name === 'Credit Config'          && has) setCreditConfig(true);
                if (sub.name === 'Coupon Config'          && has) setCreditConfig(true);
            });
            const mhas = item.module_info.permissions.indexOf(1) !== -1;
            if (item.module_info.name === 'Customers'       && mhas) setcustomers(true);
            if (item.module_info.name === 'Billing'         && mhas) setBilling(true);
            if (item.module_info.name === 'Reports'         && mhas) setReports(true);
            if (item.module_info.name === 'Supports'        && mhas) setSupports(true);
            if (item.module_info.name === 'User Management' && mhas) setManageAdmin(true);
            if (item.module_info.name === 'Settings'        && mhas) setsettings(true);
        });
    };

    const fetchMenuListApi = async () => {
        const role_id = Cookies.get('user_type');
        const token   = Cookies.get('admin_user_token');
        try {
            const response = await axios.get(`apiV1/module-mappings/?role_id=${role_id}`, {
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            });
            if (response.status === 200) {
                const items = response.data.results.results;
                Cookies.set('modulepermissions', JSON.stringify(items));
                showpageswith(items);
            }
        } catch (error) {}
    };

    useEffect(() => {
        const saved = Cookies.get('modulepermissions');
        if (saved) {
            showpageswith(JSON.parse(saved));
        } else {
            fetchMenuListApi();
        }
        Cookies.set('num_req_count', '0');
    }, []);

    const isDashboard = location.pathname === '/dashboard' || location.pathname === '/';

    return (
        <div className="vertical-menu">
            <div data-simplebar className="h-100">
                <div id="sidebar-menu">
                    <ul className="metismenu list-unstyled" id="side-menu">

                        {/* Dashboard - direct link, black box on active */}
                        <li className={isDashboard ? 'mm-active' : ''}>
                            <Link to="/dashboard" className={`dashboard-link ${isDashboard ? 'active' : ''}`}>
                                <i className="bx bx-home-alt"></i>
                                <span>Dashboard</span>
                            </Link>
                        </li>

                        {/* Customers */}
                        {customers && customerslist &&
                        <li className={liCls('customers')} onClick={() => toggleMenu('customers')}>
                            <a role="button" className={parentCls('customers')} aria-expanded={isOpen('customers')}>
                                <i className="bx bx-user-circle"></i>
                                <span>Customers</span>
                            </a>
                            <ul className={isOpen('customers') ? 'sub-menu mm-collapse mm-show' : 'sub-menu mm-collapse'}>
                                <li className={subLi('customerslist')}>
                                    <Link to="/customers/customerslist" className={subA('customerslist')}>Customers List</Link>
                                </li>
                            </ul>
                        </li>}

                        {/* Billing */}
                        {Billing && (BillingInformation || PaymentDetails || Invoice || CreateInvoice) &&
                        <li className={liCls('billing')} onClick={() => toggleMenu('billing')}>
                            <a role="button" className={parentCls('billing')} aria-expanded={isOpen('billing')}>
                                <i className="mdi mdi-account-cash-outline"></i>
                                <span>Billing</span>
                            </a>
                            <ul className={isOpen('billing') ? 'sub-menu mm-collapse mm-show' : 'sub-menu mm-collapse'}>
                                {BillingInformation &&
                                <li className={subLi('billing_info')}>
                                    <Link to="/billing/billing_info" className={subA('billing_info')}>Billing Information</Link>
                                </li>}
                                {PaymentDetails &&
                                <li className={subLi('payment_details')}>
                                    <Link to="/billing/payment_details" className={subA('payment_details')}>Payment Details</Link>
                                </li>}
                                {Invoice &&
                                <li className={subLi('invoice')}>
                                    <Link to="/billing/invoice" className={subA('invoice')}>Invoice</Link>
                                </li>}
                                {CreateInvoice &&
                                <li className={subLi('create_invoice')}>
                                    <Link to="/billing/create_invoice" className={subA('create_invoice')}>Create Invoice</Link>
                                </li>}
                            </ul>
                        </li>}

                        {/* Reports */}
                        {Reports && (Revenue || Userlogs) &&
                        <li className={liCls('reports')} onClick={() => toggleMenu('reports')}>
                            <a role="button" className={parentCls('reports')} aria-expanded={isOpen('reports')}>
                                <i className="mdi mdi-file-document-multiple-outline"></i>
                                <span>Reports</span>
                            </a>
                            <ul className={isOpen('reports') ? 'sub-menu mm-collapse mm-show' : 'sub-menu mm-collapse'}>
                                {Revenue &&
                                <li className={subLi('revenue')}>
                                    <Link to="/reports/revenue" className={subA('revenue')}>Revenue</Link>
                                </li>}
                                {Userlogs &&
                                <li className={subLi('user_logs_list')}>
                                    <Link to="/reports/user_logs_list" className={subA('user_logs_list')}>User Logs</Link>
                                </li>}
                            </ul>
                        </li>}

                        {/* Supports */}
                        {Supports && (ManageTickets || CreateTickets || TicketsCategories || PredefinedReplies) &&
                        <li className={liCls('support')} onClick={() => toggleMenu('support')}>
                            <a role="button" className={parentCls('support')} aria-expanded={isOpen('support')}>
                                <i className="mdi mdi-headset"></i>
                                <span>Supports</span>
                            </a>
                            <ul className={isOpen('support') ? 'sub-menu mm-collapse mm-show' : 'sub-menu mm-collapse'}>
                                {ManageTickets &&
                                <li className={subLi('manage_tickets')}>
                                    <Link to="/support/manage_tickets" className={subA('manage_tickets')}>Manage Tickets</Link>
                                </li>}
                                {CreateTickets &&
                                <li className={subLi('create_tickets')}>
                                    <Link to="/support/create_tickets" className={subA('create_tickets')}>Create Tickets</Link>
                                </li>}
                                {TicketsCategories &&
                                <li className={subLi('categories')}>
                                    <Link to="/support/categories" className={subA('categories')}>Ticket Categories</Link>
                                </li>}
                                {TicketsCategories &&
                                <li className={subLi('create_categories')}>
                                    <Link to="/support/create_categories" className={subA('create_categories')}>Create Categories</Link>
                                </li>}
                                {PredefinedReplies &&
                                <li className={subLi('predefined_replies')}>
                                    <Link to="/support/predefined_replies" className={subA('predefined_replies')}>Predefined Replies</Link>
                                </li>}
                            </ul>
                        </li>}

                        {/* User Management */}
                        {ManageAdmin && (MenuPermissions || UserLevel || UserList) &&
                        <li className={liCls('manage_user')} onClick={() => toggleMenu('manage_user')}>
                            <a role="button" className={parentCls('manage_user')} aria-expanded={isOpen('manage_user')}>
                                <i className="bx bx-user"></i>
                                <span>User Management</span>
                            </a>
                            <ul className={isOpen('manage_user') ? 'sub-menu mm-collapse mm-show' : 'sub-menu mm-collapse'}>
                                {UserList &&
                                <li className={subLi('user_list')}>
                                    <Link to="/manage_user/user_list" className={subA('user_list')}>User List</Link>
                                </li>}
                                {UserLevel &&
                                <li className={subLi('user_roles')}>
                                    <Link to="/manage_user/user_roles" className={subA('user_roles')}>User Roles</Link>
                                </li>}
                                {MenuPermissions &&
                                <li className={subLi('access_privileges')}>
                                    <Link to="/manage_user/access_privileges" className={subA('access_privileges')}>Access Privileges</Link>
                                </li>}
                            </ul>
                        </li>}

                        {/* Settings */}
                        {settings && (Products || Plans || Buycredit || Creditconfig) &&
                        <li className={liCls('settings')} onClick={() => toggleMenu('settings')}>
                            <a role="button" className={parentCls('settings')} aria-expanded={isOpen('settings')}>
                                <i className="bx bx-cog"></i>
                                <span>Settings</span>
                            </a>
                            <ul className={isOpen('settings') ? 'sub-menu mm-collapse mm-show' : 'sub-menu mm-collapse'}>
                                {Plans &&
                                <li className={subLi('plans')}>
                                    <Link to="/settings/plans" className={subA('plans')}>Plans</Link>
                                </li>}
                                {Buycredit &&
                                <li className={subLi('Buycredit')}>
                                    <Link to="/settings/Buycredit" className={subA('Buycredit')}>Buy Additional Credits</Link>
                                </li>}
                                <li className={subLi('Creditconfig')}>
                                    <Link to="/settings/Creditconfig" className={subA('Creditconfig')}>Coupon Config</Link>
                                </li>
                            </ul>
                        </li>}

                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Sidebar;
